// Our History slider (requires Swiper globally)
(function () {
  if (typeof window === 'undefined') return;

  function init(el) {
    if (!el || !window.Swiper) return;
    if (el.__swiper) { el.__swiper.update(); return; }

    const swiper = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 32, 
      breakpoints: {
        0:   { spaceBetween: 24 }, 
        768: { spaceBetween: 32 }  
      },

      grabCursor: true,
      simulateTouch: true,
      keyboard: { enabled: true },
      mousewheel: { forceToAxis: true, sensitivity: 0.6 },

      pagination: {
        el: el.querySelector('.swiper-pagination'),
        type: 'progressbar'
      },
      scrollbar: {
        el: el.querySelector('.swiper-scrollbar'),
        draggable: true,
        dragSize: 'auto'
      }
    });

    el.__swiper = swiper;
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-role="history-swiper"]').forEach(init);
  });
})();
